import RecipeContentMapper from 'services/mappers/recipes/RecipeContentMapper';
import RecipesService from 'services/recipes';

const editRecipe = async (id, recipeContentUIModel, oldCoverPhotoURL = '') => {
  if (!id) throw new Error('id cannot be empty');
  if (!recipeContentUIModel) throw new Error('recipeContent cannot be empty');

  let recipeContentDataModel = RecipeContentMapper.mapUIModelToDataModel(
    recipeContentUIModel
  );

  const { coverPhotoURL } = recipeContentDataModel.additionalData;
  const hasCoverPhotoChanged = coverPhotoURL !== oldCoverPhotoURL;

  if (hasCoverPhotoChanged) {
    const hasPhotoBeenRemoved = !coverPhotoURL;

    if (hasPhotoBeenRemoved)
      await RecipesService.deleteCoverPhoto(id, oldCoverPhotoURL);
    else {
      const downloadURL = await RecipesService.uploadCoverPhoto(
        id,
        coverPhotoURL
      );

      recipeContentDataModel = {
        ...recipeContentDataModel,
        additionalData: {
          ...recipeContentDataModel.additionalData,
          coverPhotoURL: downloadURL,
        },
      };
    }
  }

  await RecipesService.edit(id, recipeContentDataModel);
};

export default editRecipe;
